import React, { FC, useMemo } from "react";
import { WalletDisconnectModalBody } from "ui";
import bladeIcon from "assets/blade.png";
import hashpackIcon from "assets/hashpack.png";

// firebase analytics
import { firebaseEvents } from "utils/firebase";
import { FIREBASE_EVENT_PROPERTIES } from "constants/constants";

interface WalletDisconnectProps {
  disconnectWallet: () => void;
  walletBalance: number;
  walletData: any;
  walletAddress: string;
}

export const WalletDisconnect: FC<WalletDisconnectProps> = (props) => {
  const { walletAddress, disconnectWallet, walletData } = props;

  const walletName = useMemo(() => {
    return walletData?.pairedWalletData?.name === "HashPack"
      ? "HashPack"
      : "Blade Wallet";
  }, [walletData]);

  const trackWalletAddressCopy = () => {
    sendLog("Copy_Address");
  };
  const sendLog = (name: string) => {
    let firebaseRequest: any = {
      [FIREBASE_EVENT_PROPERTIES.EVENT_NAME]: name,
      [FIREBASE_EVENT_PROPERTIES.WALLET_NAME]: walletName,
      [FIREBASE_EVENT_PROPERTIES.WALLET_ADDRESS]: walletAddress,
    };
    firebaseEvents(firebaseRequest);
  };

  return (
    <WalletDisconnectModalBody
      walletDetails={{
        address: walletAddress,
        icon: walletName === "HashPack" ? hashpackIcon : bladeIcon,
        walletName: walletName,
        disconnect: disconnectWallet,
        trackWalletAddressCopy,
      }}
    />
  );
};

export default WalletDisconnect;
